<template>
    <div>
        <Navigation />

        <div class="mt-5">
            <div class="grid grid-cols-9 gap-2">
                <div>
                    <navigation
                        :navigation="[
                            {
                                name: 'Clicks',
                                route: { name: 'user.trackings' },
                                icon: UsersIcon,
                            },
                            {
                                name: 'Produtos',
                                route: { name: 'user.audit.products' },
                                icon: CubeIcon,
                            },
                            {
                                name: 'Afiliados',
                                route: { name: 'user.audit.affiliates' },
                                icon: UsersIcon,
                            },
                            {
                                name: 'Vendas',
                                route: { name: 'user.audit.commissions' },
                                icon: BanknotesIcon,
                            },
                            {
                                name: 'Logins',
                                route: { name: 'user.audit.logins' },
                                icon: UserIcon,
                            },
                            {
                                name: 'Financeiro',
                                route: { name: 'user.audit.finnancial' },
                                icon: CurrencyDollarIcon,
                            },
                            {
                                name: 'Metricas',
                                route: { name: 'user.metrics' },
                                icon: ChartBarIcon,
                            },
                        ]"
                    />
                </div>
                <div class="col-span-8">
                    <ticto-loading v-if="loading" />
                    <!-- Toolbar única: as páginas filhas teleportam seus controles pro slot da esquerda -->
                    <div
                        class="mb-3 flex flex-wrap items-center justify-between gap-3"
                    >
                        <div
                            id="audit-toolbar"
                            class="flex min-w-0 flex-wrap items-center gap-3"
                        ></div>

                        <div class="flex shrink-0 items-center gap-2">
                            <!-- Status de Observação -->
                            <button
                                v-if="observation"
                                type="button"
                                class="flex items-center gap-1 text-sm text-yellow-500 transition-all hover:text-yellow-600 hover:underline"
                                @click="openObservationModal"
                                v-tooltip="
                                    'Observação iniciada em ' +
                                    new Date(
                                        observation.insertedAt,
                                    ).toLocaleDateString('pt-BR', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                    }) +
                                    '. Clique para detalhes.'
                                "
                            >
                                <EyeIcon class="h-5 w-5" />
                                <span class="hidden xl:inline"
                                    >Em observação</span
                                >
                            </button>

                            <!-- Status de Auditoria: discreto, mas com o estado
                                 e a data sempre visíveis -->
                            <router-link
                                v-if="audit"
                                :to="{
                                    name: 'audit.interactions',
                                    params: { audit_id: audit.id },
                                }"
                                target="_blank"
                                class="flex items-center gap-1.5 text-xs text-gray-500 transition-colors hover:text-gray-700 hover:underline dark:text-gray-400 dark:hover:text-gray-200"
                                v-tooltip="'Ver interações da auditoria'"
                            >
                                <span
                                    class="h-1.5 w-1.5 shrink-0 rounded-full"
                                    :class="
                                        audit.status === 'closed'
                                            ? 'bg-gray-400 dark:bg-gray-500'
                                            : 'bg-amber-500'
                                    "
                                ></span>
                                Auditoria
                                {{
                                    audit.status === "closed"
                                        ? "finalizada"
                                        : "iniciada"
                                }}
                                em {{ auditDateLabel }}
                            </router-link>

                            <!-- Botões de Ação -->
                            <observation-modal
                                v-if="!observation && observationStatusLoaded"
                                :user-id="user.id"
                                button-text="Observar"
                                @fetch="fetchObservationStatus"
                            />
                            <store-modal
                                v-if="!audit"
                                @fetch="fetchAuditStatus"
                                :user-id="user.id"
                            >
                                Auditar
                            </store-modal>
                        </div>
                    </div>

                    <!-- Modal de Observação - Para referência do modal através do ref -->
                    <observation-modal
                        v-if="observation"
                        ref="observationModalRef"
                        :user-id="user.id"
                        :observation-data="observation"
                        @fetch="fetchObservationStatus"
                        :hide-button="true"
                    />

                    <router-view v-if="!loading" :user="user"></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    UsersIcon,
    CubeIcon,
    BanknotesIcon,
    UserIcon,
    CurrencyDollarIcon,
    ChartBarIcon,
    EyeIcon,
} from "@heroicons/vue/24/outline";
import UserClicks from "../../../components/user/audit/UserClicks.vue";
import Navigation from "../../../components/layouts/navigation/vertical/Navigation.vue";
import TictoLoading from "../../../components/layouts/TictoLoading.vue";
import StoreModal from "../../../components/audit/modals/StoreModal.vue";
import ObservationModal from "../../../components/user/observation/ObservationModal.vue";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
    components: {
        StoreModal,
        TictoLoading,
        Navigation,
        UserClicks,
        EyeIcon,
        ObservationModal,
    },
    props: ["user"],

    data() {
        return {
            audit: false,
            observation: null,
            observationModalRef: null,
            observationStatusLoaded: false,
            affiliates: [],
            products: [],
            table: false,
            loading: false,
            clicks: [],
            pagination: {
                total: 0,
                per_page: 35,
                current_page: 1,
                last_page: 11,
                from: 1,
                to: 11,
            },
            aggs: {
                browser: {},
                city: {},
                ip: {},
                device: {},
            },
        };
    },

    computed: {
        auditDateLabel() {
            const raw = this.audit?.created_at;

            if (!raw) {
                return "";
            }

            const parsed = new Date(String(raw).replace(" ", "T"));

            return isNaN(parsed) ? raw : parsed.toLocaleDateString("pt-BR");
        },
    },

    mounted() {
        this.fetch();
        this.fetchObservationStatus();
    },

    methods: {
        fetch() {
            this.fetchAuditStatus();
        },

        fetchAuditStatus() {
            const params = {};
            params["filter[user_id]"] = this.$route.params.user_id;

            axios
                .get("/api/audit", {
                    params,
                })
                .then(({ data }) => {
                    this.audit = data.data[0];
                });
        },

        fetchObservationStatus() {
            axios
                .get(`/api/user/observation/${this.user.id}`)
                .then(({ data }) => {
                    if (data.data.isUnderObservation) {
                        this.observation = data.data;
                    } else {
                        this.observation = false;
                    }
                    this.observationStatusLoaded = true;
                })
                .catch((error) => {
                    console.error(
                        "Erro ao verificar status de observação:",
                        error,
                    );
                    this.observation = false;
                    this.observationStatusLoaded = true;
                });
        },

        openObservationModal() {
            if (this.$refs.observationModalRef) {
                this.$refs.observationModalRef.openModal();
            }
        },

        UsersIcon,
        CubeIcon,
        BanknotesIcon,
        UserIcon,
        CurrencyDollarIcon,
        ChartBarIcon,
        async syncWithClickUp() {
            try {
                await axios.post(`/api/v1/audit/${route.params.id}/clickup`);
                toast.success("Task sincronizada com sucesso!");
            } catch (error) {
                toast.error("Erro ao sincronizar com ClickUp");
            }
        },
    },
};
</script>
